import React, { useContext, useEffect, useRef, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Socket from "../../../../context/SocketContext";
import "./BuySell.css";
import moment from "moment";
import { Label, TextInput } from "flowbite-react";
import toast from "react-hot-toast";
import { Dark } from "../../../../Theme/Theme";
import Qty from "./Qty/Qty";
import Bid from "./Bid";
import Ask from "./Ask";
import High from "./High";
import Low from "./Low";
import Ltp from "./Ltp";
import Chnage from "./Chnage";
import useSound from "use-sound";
import Loading from "react-loading";
import Backend from "../../../../Backend/Backend";
import Error from "../../../../Sound/Error.wav";
import BuyMp3 from "../../../../Sound/buy.mp3";
import SellMp3 from "../../../../Sound/sell.mp3";

const backend = await new Backend().init();

export default function BuySell({ symbolData, buyselltype, close }) {
  const userType = Number(localStorage.getItem("user_type") || 7);

  // 🎧 Sound hooks
  const [errorsound] = useSound(Error);
  const [buysound] = useSound(BuyMp3);
  const [sellsound] = useSound(SellMp3);

  const socket = useContext(Socket);
  const Selecter = useRef(null);
  const windowSize = useSize();

  const [symbolQty, setSymbolQty] = useState("");
  const [usdInr, setUsdInr] = useState(null);

  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [user_id, setUserId] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [tpassword, setTPassword] = useState("");
  const [userlist, setUserList] = useState([]);

  useEffect(() => {
    // 🧩 Defensive guard
    if (!symbolData) return null;

    socket.emit("giverate", symbolData.symbol_id);
    socket.on("trade" + symbolData.symbol_id, handleTrade);

    loadUser();

    Selecter.current?.focus();

    // Default qty setup
    const defaultQty =
      symbolData.type === "nse" ||
      symbolData.type === "nse_cash" ||
      symbolData.type === "us_stock" ||
      symbolData.type === "sgx" ||
      symbolData.type === "index"
        ? JSON.parse(symbolData.min_qty)
        : JSON.parse(symbolData.min_qty / symbolData.lot_size);

    setQty(defaultQty || "");

    symbols();

    return () => socket.off("trade" + symbolData.symbol_id, handleTrade);
  }, [symbolData]);

  const handleTrade = (data) => {
    if (data?.LastUpdateTime && data.LastUpdateTime !== time) {
      setTime(data.LastUpdateTime);
    }
  };

  const symbols = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol_id: symbolData.symbol_id,
    };

    backend.symbol_qty(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setSymbolQty(r.symbol);
        setUsdInr(r.usdInr);
      } else {
        toast.error(r.message);
      }
    });
  };

  const submit = () => {
    Buy_Sell(buyselltype);
  };

  const cancel = () => {
    close?.();
  };

  const Buy_Sell = (type) => {
    if (!user_id) {
      toast.error("SELECT USER FIRST!");
      return;
    }
    if (!qty || qty <= 0) {
      toast.error("INVALID ORDER QTY!");
      return;
    }
    if (!tpassword) {
      toast.error("INVALID TPASSWORD!");
      return;
    }

    setLoading(true);

    // 🧠 Prepare payload
    const baseData = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id,
      qty_order: qty,
      price,
      symbol_id: symbolData.symbol_id,
      password: tpassword,
      symbol: symbolData.symbol_display ?? symbolData.symbol,
      type,
      symbol_type: symbolData.type,
    };

    // 🧩 Add role field based on userType
    if (userType === 1) baseData.admin = "1";
    else if (userType === 2) baseData.super = "1";
    else if (userType === 3) baseData.master = "1";
    else if (userType === 5) baseData.broker = "1";
    else if (userType === 6) baseData.subbroker = "1";

    backend.mtrade(baseData).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success(r.message);
        type === 0 ? buysound() : sellsound();
      } else {
        toast.error(r.message);
        errorsound();
      }
    });
  };

  const loadUser = () => {
    setLoading(true);
    const baseData = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    // 🧩 Add role field based on userType
    if (userType === 1) baseData.admin_id = localStorage.getItem("id");
    else if (userType === 2) baseData.super_id = localStorage.getItem("id");
    else if (userType === 3) baseData.master_id = localStorage.getItem("id");
    else if (userType === 5) baseData.broker_id = localStorage.getItem("id");

    backend.load_user(baseData).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setUserList(r.user || []);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
    <div
      className={`${buyselltype === 0 ? "buy" : "sell"} buysellmodal`}
      style={{
        height: windowSize[1] / 3.5,
        width: windowSize[0] / 1.1,
      }}
    >
      {/* 🟦 Header */}
      <div className="buysellType">
        <div className="typeText">{buyselltype === 0 ? "BUY" : "SELL"}</div>
      </div>

      {/* 🟩 Symbol Info */}
      <div className="buysellSymbol">
        <div
          className={`symbol ${buyselltype === 0 ? "symbolbuy" : "symbolsell"}`}
        >
          <div className="symbolName">
            {symbolData.symbol_display ?? symbolData.symbol}
            <div className="symbolexpiry">
              {symbolData.type === "nse_cash"
                ? "EQUITY"
                : moment(symbolData.expiry_date).format("DD-MMM")}
            </div>
          </div>
        </div>

        {/* 🧾 Order Inputs */}
        <div className="buysell">
          <div className="order">
            <div className="enterorder">
              {/* User Select */}
              <div className="orderselect">
                <Label
                  value="SELECT USER"
                  className="uppercase font-semibold text-xs"
                />
                <select
                  className="selecter"
                  onChange={(e) => setUserId(e.target.value)}
                  value={user_id}
                >
                  <option value="">SELECT USER</option>
                  {userlist.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.username}
                    </option>
                  ))}
                </select>
              </div>

              {/* Qty */}
              <div className="orderselect">
                <Label
                  value={
                    symbolData.type === "nse" || symbolData.type === "nse_cash"
                      ? "QTY"
                      : "LOT"
                  }
                  className="uppercase font-semibold text-xs"
                />
                <TextInput
                  ref={Selecter}
                  type="number"
                  placeholder={
                    symbolData.type === "nse" ||
                    symbolData.type === "nse_cash" ||
                    symbolData.type === "us_stock" ||
                    symbolData.type === "sgx" ||
                    symbolData.type === "index"
                      ? "ENTER QTY"
                      : "ENTER LOT"
                  }
                  required
                  className="qty mousetrap"
                  value={qty}
                  onKeyDownCapture={(e) => {
                    if (e.key === "Enter") submit();
                  }}
                  step="0.01" // ⭐ allows 0.01, 0.1, 0.25 etc.
                  min="0.01" // optional: prevent entering 0 or negative
                  onChange={(e) => setQty(e.target.value)}
                />
              </div>

              {/* Price */}
              {userType === 1 ? (
                <div className="orderselect">
                  <Label
                    value="Price"
                    className="uppercase font-semibold text-xs"
                  />
                  <TextInput
                    type="number"
                    placeholder="PRICE"
                    required
                    className="qty mousetrap"
                    value={price}
                    step="0.01" // ⭐ allows 0.01, 0.1, 0.25 etc.
                    min="0.01" // optional: prevent entering 0 or negative
                    onChange={(e) => setPrice(e.target.value)}
                    onKeyDownCapture={(e) => {
                      if (e.key === "Enter") submit();
                    }}
                  />
                </div>
              ) : null}

              {/* TPassword */}
              <div className="orderselect">
                <Label
                  value="TPassword"
                  className="uppercase font-semibold text-xs"
                />
                <TextInput
                  placeholder="TPASSWORD"
                  required
                  className="qty mousetrap"
                  value={tpassword}
                  onChange={(e) => setTPassword(e.target.value)}
                  onKeyDownCapture={(e) => {
                    if (e.key === "Enter") submit();
                  }}
                />
              </div>
            </div>

            {/* Submit/Cancel */}
            <div className="submit">
              <div className="submitContainer">
                <button onClick={loading ? null : submit} className="btnorder">
                  {loading ? (
                    <Loading
                      type="spin"
                      color={Dark.text}
                      height={20}
                      width={20}
                    />
                  ) : (
                    "SUBMIT"
                  )}
                </button>
              </div>
              <div className="cancelContainer">
                <button onClick={loading ? null : cancel} className="btncancel">
                  {loading ? (
                    <Loading
                      type="spin"
                      color={Dark.text}
                      height={20}
                      width={20}
                    />
                  ) : (
                    "CANCEL"
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Bid / Ask / High / Low */}
          <div className="bidhigh">
            <div
              className={`bidcontainer ${
                buyselltype === 0 ? "symbolbuy" : "symbolsell"
              }`}
            >
              <Bid symbol_id={symbolData.symbol_id} />
            </div>
            <div
              className={`highcontainer ${
                buyselltype === 0 ? "symbolbuy" : "symbolsell"
              }`}
            >
              <High symbol_id={symbolData.symbol_id} />
            </div>

            {usdInr == null ? null : (
              <div
                className={`highcontainer addTop ${
                  buyselltype === 0 ? "symbolbuy" : "symbolsell"
                }`}
              >
                <Bid symbol_id={usdInr.symbol_id} usdInr={1} />
              </div>
            )}
          </div>

          <div className="asklow">
            <div
              className={`askcontainer ${
                buyselltype === 0 ? "symbolbuy" : "symbolsell"
              }`}
            >
              <Ask symbol_id={symbolData.symbol_id} />
            </div>
            <div
              className={`lowcontainer ${
                buyselltype === 0 ? "symbolbuy" : "symbolsell"
              }`}
            >
              <Low symbol_id={symbolData.symbol_id} />
            </div>

            {usdInr == null ? null : (
              <div
                className={`lowcontainer addTop ${
                  buyselltype === 0 ? "symbolbuy" : "symbolsell"
                }`}
              >
                <Ask symbol_id={usdInr.symbol_id} usdInr={1} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 🟨 LTP + Change + Qty */}
      <div className="buysellData">
        <div className="LtpChnagr">
          <div className="LtpLeft">
            <div className="Ltp">LTP</div>
            <div className="Chnage">CHANGE</div>
          </div>
          <div className="LtpRight">
            <Ltp symbol_id={symbolData.symbol_id} />
            <Chnage symbol_id={symbolData.symbol_id} />
          </div>
        </div>
        <Qty symbolQty={symbolQty} />
      </div>
    </div>
  );
}
